import React from 'react';
import PropTypes from 'prop-types';

import Button from '@material-ui/core/Button';

import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import Dialog from '@material-ui/core/Dialog';




function ConfirmationDialogRaw(props) {
  const { onClose, value: valueProp, open, ...other } = props;
  const [value, setValue] = React.useState(valueProp);
  

  React.useEffect(() => {
    if (!open) {
      setValue(valueProp);
    }
  }, [valueProp, open]);

  

  function handleCancel() {
    onClose();
  }

  function handleOk() {
     props.cancel();
    onClose(value);

  }

 

  return (
    <Dialog
      disableBackdropClick
      disableEscapeKeyDown
      maxWidth="xs"
      
      aria-labelledby="confirmation-dialog-title"
      open={open}
      {...other}
    >
      <DialogTitle id="confirmation-dialog-title">Are you sure you want to cancel this order...?</DialogTitle>
     
      <DialogActions>
        <Button onClick={handleCancel} color="primary">
          NO
        </Button>
        <Button onClick={handleOk} color="primary">
          Yes
        </Button>
      </DialogActions>
    </Dialog>
  );
}

ConfirmationDialogRaw.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  value: PropTypes.string.isRequired,
};



function Cancel(props) {
  
  const [open, setOpen] = React.useState(false);
  const [value, setValue] = React.useState('Dione');

  function handleClickListItem() {
    setOpen(true);
  }

  function handleClose(newValue) {
    setOpen(false);

    if (newValue) {
      setValue(newValue);
    }
  }

  return (
    <div>
     
       
      
     <Button  variant="outlined" style={{maxWidth:"350px",width:"90%"}}  onClick={handleClickListItem} disabled={props.dis} color="secondary">Cancel Order</Button>
      
          
      
        <ConfirmationDialogRaw
          cancel={props.cancel}

          keepMounted
          open={open}
          onClose={handleClose}
          value={value}
        />
    
    </div>
  );
}

export default Cancel;
